// Modelo de order
export default class Order {
    constructor(
        public field: string = '',
        public typeOrder: string = '',
    ) {
        
    }
}
